import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { logger } from '../logger';
export function lastCreatedAt() {
    return pipe(map((group) => {
        if (!Array.isArray(group)) {
            logger.error(`lastCreatedAt must be piped an array`);
            return group;
        }
        if (group.length === 0) {
            return undefined;
        }
        return group.reduce((prev, current) => {
            if (!prev.clientCreatedAt || !current.clientCreatedAt) {
                logger.error('No clientCreatedAt property was found on wall item ID ' + current.id);
                return current;
            }
            return prev.clientCreatedAt.seconds > current.clientCreatedAt.seconds
                ? prev
                : current;
        });
    }));
}
//# sourceMappingURL=last_created_at.js.map